// @flow
import BrandLoader from './BrandLoader';

const FullScreenLoaderStyle = {
  flexGrow: 1,
  alignItems: 'center',
  justifyContent: 'center'
};

export default function AppLoader() {
  return <BrandLoader style={FullScreenLoaderStyle} />;
}
